import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'roo-ui/components';
import { Flag } from 'pages/Property/LegacyPropertyAvailability/RoomTypes/primitives';

const OfferDepositPayMessage = ({ depositPay }) => {
  const isDepositPayable = !!depositPay?.depositPayable;

  if (!isDepositPayable) return null;

  return (
    <Flag icon="depositPay" color="green" mb={3}>
      <Text fontSize={['sm', 'base']} fontWeight="bold">
        Deposit Pay
      </Text>
    </Flag>
  );
};

OfferDepositPayMessage.propTypes = {
  depositPay: PropTypes.object,
};

OfferDepositPayMessage.defaultProps = {
  depositPay: {
    depositPayable: false,
  },
};

export default OfferDepositPayMessage;
